'use strict';

angular.module('inetsys.tools', []).factory('InetsysTools', function() {
    return {
        simpleCopy: function simpleCopy(source) {
            if (!source || typeof source !== 'object') {
                return source;
            }

            var destination = angular.isArray(source) ? [] : {};
            for (var key in source) {
                destination[key] = source[key];
            }

            return destination;
        },
    };
});
